import MkuDrop from './src/_drop';

export default MkuDrop;
